module.exports = __webpack_public_path__ + "portal-static/img/phone@2x.cf5966d1.png";